export const UPDATE_EQUIPMENT_INFO = "UPDATE_EQUIPMENT_INFO";
export const UPDATE_EQUIPMENT_INFO_SUCCESS = "UPDATE_EQUIPMENT_INFO_SUCCESS";
export const UPDATE_EQUIPMENT_INFO_FAILURE = "UPDATE_EQUIPMENT_INFO_FAILURE";
export const CLEAR_UPDATE_EQUIPMENT_INFO_ERROR = "CLEAR_UPDATE_EQUIPMENT_INFO_ERROR";
